var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#20A74E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2829 4.23562C10.1352 4.10912 9.94335 4.04661 9.74964 4.06182C9.55593 4.07703 9.37617 4.16872 9.24987 4.31673L6.09504 8.01541L4.39783 6.59509C4.33064 6.53715 4.25263 6.49317 4.16834 6.46572C4.08405 6.43827 3.99515 6.42789 3.90682 6.43518C3.81849 6.44248 3.73249 6.4673 3.65382 6.5082C3.57514 6.54911 3.50536 6.60529 3.44853 6.67347C3.3917 6.74164 3.34896 6.82047 3.32279 6.90535C3.29662 6.99023 3.28754 7.07949 3.29608 7.16792C3.30462 7.25635 3.33061 7.3422 3.37254 7.42047C3.41447 7.49875 3.47151 7.56789 3.54033 7.62387L5.81419 9.5271C5.88431 9.5857 5.96571 9.6292 6.05333 9.65489C6.14095 9.68057 6.23291 9.68789 6.32347 9.67639C6.41952 9.66895 6.51316 9.6426 6.59903 9.59884C6.68491 9.55508 6.76133 9.49477 6.82393 9.42137L10.3633 5.27087C10.4894 5.12269 10.5517 4.93043 10.5365 4.73628C10.5213 4.54213 10.4298 4.36196 10.2823 4.2353",
    fill: "#20A74E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBorder);
export default __webpack_public_path__ + "static/media/right-border.3e7e065c08eec5d23b0fbd6f795cd4b9.svg";
export { ForwardRef as ReactComponent };